import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Table } from 'antd'

@inject((store: any) => {
    const { insuranceCalculatorStore, popupStore, companiesStore } = store
    return { insuranceCalculatorStore, popupStore, companiesStore }
})
@observer
export default class DuplicatesTable extends Component<any, any> {
    render() {
        const { insuranceCalculatorStore, sets, drug, filteredMainInsuranceCases, hmoCompanies } = this.props
        let newKefelHeser = insuranceCalculatorStore.newKefelHeser
        const { insuranceCases } = insuranceCalculatorStore
        const loading = insuranceCalculatorStore.loading

        const columns = [
            {
                title: 'ביטוחים',
                key: 'right_param_set_id',
                render: (_, record) => (
                    <span>
                        {record.right_param_set_id != 20 ? sets[`id${record.right_param_set_id}`] : drug}
                        {checkIfIndeminficationOrCompensation(record)}
                    </span>
                )
            },
            {
                title: 'היכן הביטוחים',
                key: 'options',
                render: (_, record) => (
                    <div>
                        {insuranceCases
                            .filter(ins => ins.right_param_set_id == record.right_param_set_id)
                            .map((ins, ind) => (
                                <div key={ind}>
                                    {ins.company_name
                                        .split(' ')
                                        .filter(name => name != 'חברה' && name != 'לביטוח')
                                        .join(' ')}
                                    - {Math.round(ins.policy_price)} ₪
                                </div>
                            ))}
                    </div>
                )
            },
            {
                title: `כיסויים כפולים זהים`,
                key: 'duplicates',
                render: (_, record) => (
                    <span>
                        <div>
                            {Object.values(record.rights)
                                .filter(
                                    right =>
                                        right.exist.filter(it => !hmoCompanies[record.policies[it].company_id]).length >
                                        1
                                )
                                .map((right, ind) => {
                                    if (ind == 0 || ind == 1) return <div key={ind}>{right.name}</div>
                                    if (ind == 2)
                                        return (
                                            <div
                                                key={ind}
                                                style={{
                                                    textDecoration: 'underline',
                                                    color: 'blue',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    this.props.popupStore.togglePopup('clarification', {
                                                        title: 'כיסויים כפולים זהים',
                                                        rights: Object.values(record.rights).filter(
                                                            right =>
                                                                right.exist.filter(
                                                                    it => !hmoCompanies[record.policies[it].company_id]
                                                                ).length > 1
                                                        )
                                                    })
                                                }}
                                            >
                                                קרא עוד...
                                            </div>
                                        )
                                })}
                        </div>
                    </span>
                )
            }
        ]
        filteredMainInsuranceCases.map((insurance, ind) => {
            columns.push({
                title: `ייחודי ב${insurance.name}`,
                key: ind,
                render: (_, record) => (
                    <span>
                        {insuranceCases.find(
                            ins =>
                                ins.policy_type === insurance.policy_type &&
                                ins.right_param_set_id == record.right_param_set_id &&
                                ins.company_id == insurance.company_id
                        ) &&
                            Object.values(record.rights)
                                .filter(
                                    right =>
                                        (right.exist.length === 1 &&
                                            record.policies[right.exist[0]].company_id == insurance.company_id) ||
                                        (right.exist.length === 2 &&
                                            ((record.policies[right.exist[0]].company_id == insurance.company_id &&
                                                hmoCompanies[record.policies[right.exist[1]].company_id]) ||
                                                (record.policies[right.exist[1]].company_id == insurance.company_id &&
                                                    hmoCompanies[record.policies[right.exist[0]].company_id])))
                                )
                                .map((right, ind) => {
                                    if (ind < 2) {
                                        return <div key={ind}>{right.name}</div>
                                    }
                                    if (ind === 2) {
                                        return (
                                            <div
                                                key={ind}
                                                className="description"
                                                style={{
                                                    textDecoration: 'underline',
                                                    color: 'blue',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    this.props.popupStore.togglePopup('clarification', {
                                                        title: `ייחודי ב${insurance.name}`,
                                                        rights: Object.values(record.rights).filter(
                                                            right =>
                                                                (right.exist.length === 1 &&
                                                                    record.policies[right.exist[0]].company_id ==
                                                                        insurance.company_id) ||
                                                                (right.exist.length === 2 &&
                                                                    ((record.policies[right.exist[0]].company_id ==
                                                                        insurance.company_id &&
                                                                        hmoCompanies[
                                                                            record.policies[right.exist[1]].company_id
                                                                        ]) ||
                                                                        (record.policies[right.exist[1]].company_id ==
                                                                            insurance.company_id &&
                                                                            hmoCompanies[
                                                                                record.policies[right.exist[0]]
                                                                                    .company_id
                                                                            ])))
                                                        )
                                                    })
                                                }}
                                            >
                                                קרא עוד...
                                            </div>
                                        )
                                    }
                                })}
                    </span>
                )
            })
        })
        columns.push({
            title: 'הבהרה',
            key: 'clarification',
            render: (_, record) => <span />
        })
        let rows = newKefelHeser.sets
            ? Object.entries(newKefelHeser.sets)
                  .filter(
                      ([key, value]) =>
                          key != 9 &&
                          key != 14 &&
                          key != 19 &&
                          value.policies.filter(policy => !hmoCompanies[policy.company_id]).length > 1
                  )
                  .map(([key, value]) => {
                      value.right_param_set_id = key
                      return value
                  })
            : []

        const getUniqueRights = (value, insurance) => {
            return Object.entries(value.rights)
                .filter(
                    ([id, right]) =>
                        (right.exist.length === 1 &&
                            value.policies[right.exist[0]].company_id == insurance.company_id) ||
                        (right.exist.length === 2 &&
                            ((value.policies[right.exist[0]].company_id == insurance.company_id &&
                                hmoCompanies[value.policies[right.exist[1]].company_id]) ||
                                (value.policies[right.exist[1]].company_id == insurance.company_id &&
                                    hmoCompanies[value.policies[right.exist[0]].company_id])))
                )
                .map(([id, right]) => {
                    const policy1 = value.policies[right.exist[0]]
                    const policy2 = value.policies[right.exist[1]]
                    if (right.exist.length == 1) {
                        right.indemnification = policy1 ? policy1.rights[id] == 'שיפוי' : false
                        right.compensation = policy1 ? policy1.rights[id] == 'פיצוי' : false
                    }
                    if (right.exist.length == 2) {
                        right.indemnification =
                            value.policies[right.exist[0]].company_id == insurance.company_id &&
                            hmoCompanies[value.policies[right.exist[1]].company_id]
                                ? policy1
                                    ? policy1.rights[id] == 'שיפוי'
                                    : false
                                : policy2
                                ? policy2.rights[id] == 'שיפוי'
                                : false
                        right.compensation =
                            value.policies[right.exist[0]].company_id == insurance.company_id &&
                            hmoCompanies[value.policies[right.exist[1]].company_id]
                                ? policy1
                                    ? policy1.rights[id] == 'פיצוי'
                                    : false
                                : policy2
                                ? policy2.rights[id] == 'פיצוי'
                                : false
                    }
                    return right
                })
        }

        const getDuplicateRights = value => {
            return Object.entries(value.rights)
                .filter(
                    ([id, right]) => right.exist.filter(it => !hmoCompanies[value.policies[it].company_id]).length > 1
                )
                .map(([id, right]) => {
                    const policy =
                        value.policies[right.exist.find(policy => !hmoCompanies[value.policies[policy].company_id])]
                    right.indemnification = policy ? policy.rights[id] == 'שיפוי' : false
                    right.compensation = policy ? policy.rights[id] == 'פיצוי' : false
                    return right
                })
        }

        const checkIfIndeminficationOrCompensation = value => {
            const duplicateRights = getDuplicateRights(value)
            let uniqueRights = []
            filteredMainInsuranceCases.map(insurance => uniqueRights.push(getUniqueRights(value, insurance)))
            let indemnification = true
            let compensation = true
            const rights = [...duplicateRights, ...uniqueRights.flat()]
            rights.map(right => {
                if (right.compensation) indemnification = false
                else if (right.indemnification) compensation = false
            })
            return indemnification ? (
                <div>
                    (<span className="green">שיפוי</span>)
                </div>
            ) : compensation ? (
                <div>
                    (<span className="blue">פיצוי</span>)
                </div>
            ) : (
                <div>
                    (<span className="green">שיפוי</span> /<span className="blue">פיצוי</span>)
                </div>
            )
        }

        return (
            <Table
                className="center-table"
                style={{ width: '100%' }}
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={rows}
            />
        )
    }
}
